"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIRTIME_PURCHASE_STATUSES = void 0;
exports.AIRTIME_PURCHASE_STATUSES = {
    PENDING: "PENDING",
    ORDERED: "ORDERED",
};
